import React, { useContext } from "react";

import DataContext from "../../../../../../../context/DataContext";

import AlternateContacts from "./AlternateContacts";
import PrimaryContacts from "./PrimaryContacts";

export default function ContactMangementSection({ caseObj }) {
  const { userRoles } = useContext(DataContext);
  return (
    <div className="pb-5">
      <PrimaryContacts
        caseObj={caseObj}
        editPermissions={userRoles.permissions.includes("users.change_user")}
      />
      {!userRoles.permissions.includes("users.view_usercontactinfo") ? (
        <h2 className="my-2 text-center text-gray-500 underline">
          Content details not available for this account at this time
        </h2>
      ) : (
        <AlternateContacts
          caseObj={caseObj}
          editPermissions={userRoles.permissions.includes("users.change_usercontactinfo")}
          deletePermissions={userRoles.permissions.includes("users.delete_usercontactinfo")}
        />
      )}
    </div>
  );
}
